import React, { Component } from "react";
import uploadIcon from '../../../assets/images/Icon feather-upload-cloud.png'
import { format } from "date-fns";
import { connect } from "react-redux";
import { newHireAction } from "../../../store/actions/file-conversion/newHire";
import { Buffer } from 'buffer'
import FileUpload from "../../../components/file-upload";

class NewHireCheckView extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    src: null,
    file: null,
    fileConvertError: false,
  };

  onSelectFile = (e, drop) => {
    let file = drop ? e.dataTransfer.files[0] : e.target.files[0];
    if (!file) return;
    let reader = new FileReader();
    this.setState({
      file: file,
      fileConvertError: null,
      newHireFileName: file.name,
    });
    reader.readAsDataURL(file);
    reader.onload = (res) =>
      this.setState({
        src: res.target.result,
      });
  };

  uploadFile = async (fileInput) => {
    const i = this.state.src.indexOf("base64,");
    const buffer = Buffer.from(this.state.src.slice(i + 7), "base64");
    const file = new File([buffer], "name", {
      type: "text/plain",
    });

    const fd = new FormData();
    fd.append("file", file);
    fd.append("filename", file.name);
    await this.props.newHireAction(fd);
    let newHire = this.props.NewHireReducer;

    if (!newHire)
      return this.setState({ fileConvertError: "Error converting file" });
    const url = window.URL.createObjectURL(
      new Blob([newHire], { type: "application/*" })
    );

    fileInput.current.value = null;
    this.setState({
      src: null,
      newHireFileName: "",
    });
    let date = new Date();
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `New-hire-${format(date, "MM-dd-yy-mmss")}.txt`
    );
    document.body.appendChild(link);
    link.click();

  };

  render() {
    return (
      <FileUpload
        HtmlFor="upld_new_hire_file"
        FileError={this.state.fileConvertError}
        CAPTION="NEW HIRE VALIDATION"
        OnSelectFile={this.onSelectFile}
        UploadFile={this.uploadFile}
        Color="#83eb47"
        Accept=".csv,.txt"
      />

    );
  }
}
const mapStateToProps = ({ UserReducer, NewHireReducer }) => ({ UserReducer, NewHireReducer });

export default connect(mapStateToProps, { newHireAction })(NewHireCheckView);;
